import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.producer,
    routes: [
        {
            path: '/quality-status',
            component: FuseLoadable({
                loader: () => import('./QualityStatusApp'),
            }),
        },
    ],
};

export default [Index];
